export default __webpack_public_path__ + "static/AWS_Buildon_2019-20b5c0dc44802b94bf0cb7c60d6a01ad.jpg";